import { ProjectCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectCategory(): Observable<ProjectCategoryDto[]> {
    return this.http.get<ProjectCategoryDto[]>(this.url + 'project-category');
  }

  createProjectCategory(
    data: ProjectCategoryDto[]
  ): Observable<ProjectCategoryDto[]> {
    return this.http.post<ProjectCategoryDto[]>(
      this.url + 'project-category',
      data
    );
  }
  getSingleProjectCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'project-category/' + id);
  }

  updateProjectCategory(
    data: ProjectCategoryDto[]
  ): Observable<ProjectCategoryDto[]> {
    return this.http.post<ProjectCategoryDto[]>(
      this.url + 'project-category/update',
      data
    );
  }

  deleteProjectCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-category', ids.join(', '));
    return this.http.delete(this.url + 'project-category', httpOptions);
  }
}
